const Keys = {
    GOOGLE:{
        ANALYTICS:{
            TRACKING_CODE: "UA-123166548-1",
        },
    },
    IDENTITY_SERVER: {
        CLIENT_ID: "cemig_saude_autorizador_frontend",
        AUTHORITY: "https://autorizador-idsrv.cemigsaude.org.br", /* PRODUCTION */
        RESPONSE_TYPE: "token id_token",
        SCOPE: "openid profile"
    },
    SERVICOS:{
        API: {
            ROOT_URL: "https://autorizador-api.cemigsaude.org.br", /* PRODUCTION */
            KEY: "?key=AUTORIZADOR971231",
        }
    },
    BIOMETRIA:{
        ORIGIN:"https://autorizador.cemigsaude.org.br" /* PRODUCTION */
    }
}

export default Keys